export const biezacyRok = 2020
const year = new Date().getFullYear()
export const koniecWaznosciLicencji = '31.12.' + year.toString()

// RAKS
export const politykaPrywatnosciURL =
  'https://ftp.raks.pl/marketing/download/pdf/pdf_polityka_prywatnosci.pdf'
export const regulaminURL =
  'https://ftp.raks.pl/marketing/download/files/regulamin_esprawozdania.pdf'
export const filmURL = 'https://www.youtube.com/watch?v=Y5EZWhSaxCw'
export const instrukcjaImportuURL =
  'https://ftp.raks.pl/marketing/download/files/Instrukcja_importu_CSV_do_eSF.pdf'

// WEB BROWSERS
export const chromeDownloadURL = 'https://www.google.com/intl/pl_ALL/chrome/'
export const mozillaDownloadURL = 'https://www.mozilla.org/pl/firefox/'
export const operaDownloadURL = 'https://www.opera.com/pl/computer'
export const edgeDownloadURL =
  'https://www.microsoft.com/pl-pl/windows/microsoft-edge/'

// TPAY
export const tpayPaymentURL = 'https://secure.tpay.com/?id=34473'

// INNE
export const krsURL = 'https://ekrs.ms.gov.pl/'
export const podatkiGovURL =
  'https://www.podatki.gov.pl/e-sprawozdania-finansowe/aplikacja/'
